export default "__VITE_ASSET__Cgfz$GnP__"